import axios from "axios";

/**
 * Pasang interceptor global untuk menangani 401 (unauthorized).
 * Dipanggil sekali dari entry point aplikasi (mis. NextApp).
 */
const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;

      if (status === 401) {
        // Jangan redirect jika kita sedang berada di halaman Smart TV / National Operation Dashboard
        if (window.location.pathname.includes("/race/national-operation-dashboard")) {
          return Promise.reject(error);
        }

        try {
          // Bersihkan data auth utama
          localStorage.removeItem("token");
          localStorage.removeItem("jobdesk");
          localStorage.removeItem("cabang");
          localStorage.removeItem("fullname");
          localStorage.removeItem("level");
          localStorage.removeItem("loginBu");
          localStorage.removeItem("buBrenchid");
          localStorage.removeItem("buBrench");

          // Redirect paksa ke halaman login utama
          window.location.href = "/signin";
        } catch (e) {
          // Jika localStorage tidak tersedia atau gagal, tetap lanjut reject
        }
      }

      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;

